import { render, staticRenderFns } from "./TurnaroundPanel.vue?vue&type=template&id=b1e1c52a&scoped=true&"
import script from "./TurnaroundPanel.vue?vue&type=script&lang=js&"
export * from "./TurnaroundPanel.vue?vue&type=script&lang=js&"
import style0 from "./TurnaroundPanel.vue?vue&type=style&index=0&id=b1e1c52a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e1c52a",
  null
  
)

export default component.exports